import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import './theme/orbital.css';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('orbital-lint: #root element missing from index.html');
}

// BrowserRouter wraps the whole tree so any descendant can use NavLink,
// useNavigate, Outlet, etc. Introduced in T029 alongside the Layout shell —
// before this commit App rendered a single placeholder card with no router.
ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
